import { verticalRequest } from './http';

// A condo's own files (notice, minutes, house rules). Administrators only.
// `type` is `notice`, `mom` or `house_rules` (the Condo Details tab "rules" is
// `house_rules` here). Query: `type`, `search`, `sort` (`newest` | `name_asc` |
// `name_desc`), `page`, `page_size`. Links in `url` are direct S3 links that
// expire after an hour, so a list is re-read rather than kept.
export const listDocuments = (condoId, params) =>
  verticalRequest({ path: `/condos/${condoId}/documents`, params });

// One file per request. `form` is a FormData with `file`, `type` and
// optionally `title` and `bot_visible`. When the file goes to the bot this
// uses the plan's word limit and credits (402), and nothing is kept on any
// failure.
export const uploadDocument = (condoId, form) =>
  verticalRequest({
    method: 'post',
    path: `/condos/${condoId}/documents`,
    data: form,
  });

// Partial `{title, type, bot_visible}`. Turning the bot switch on sends the
// file to the knowledge base (credits); off removes it from there.
export const updateDocument = (condoId, docId, fields) =>
  verticalRequest({
    method: 'put',
    path: `/condos/${condoId}/documents/${docId}`,
    data: fields,
  });

// 204. 502 `knowledge_unavailable` leaves the row, so a deleted notice never
// keeps answering tenants.
export const deleteDocument = (condoId, docId) =>
  verticalRequest({
    method: 'delete',
    path: `/condos/${condoId}/documents/${docId}`,
  });

// `{id, status, error, word_count}`. While the row is `processing` each call
// asks the knowledge service once.
export const getDocumentStatus = (condoId, docId) =>
  verticalRequest({ path: `/condos/${condoId}/documents/${docId}/status` });

// `{condo_id, graph_enabled, graph_locked, dataset_created, documents_in_bot}`.
// `graph_locked` is true while any document of the condo is in the bot.
export const getCondoKnowledge = condoId =>
  verticalRequest({ path: `/condos/${condoId}/knowledge` });

// `{graph_enabled}`; 409 `graph_locked` while documents are in the bot.
export const putCondoKnowledge = (condoId, graphEnabled) =>
  verticalRequest({
    method: 'put',
    path: `/condos/${condoId}/knowledge`,
    data: { graph_enabled: graphEnabled },
  });
